import axios from 'axios';
import { isFeatureEnabled } from '../jsx/components/Util/featureFlags';

/*
 * Impostazioni di sistema del super admin (docs/richieste-backend.md, capitoli 8 e 9):
 * - giorni dei solleciti automatici dei certificati medici;
 * - posta in uscita (server SMTP di tutte le email del portale SportID, attiva dopo la migrazione da AWS).
 *
 * SIMULAZIONE: finché il backend non ha le rotte i valori stanno nel localStorage di questo browser.
 * Con REACT_APP_IMPOSTAZIONI_BACKEND=S si usano le rotte vere.
 */
export const IMPOSTAZIONI_SIMULAZIONE = !isFeatureEnabled(process.env.REACT_APP_IMPOSTAZIONI_BACKEND ?? 'N');

const CHIAVE_SOLLECITI = 'sid-solleciti-certificati-simulazione';
const CHIAVE_POSTA = 'sid-posta-in-uscita-simulazione';

export const SOLLECITI_PREDEFINITI = { firstReminderDays: 7, secondReminderDays: 14, thirdReminderDays: 30 };
export const EMAIL_DI_PROVA = 'maurizio.deangelis@gmail.com';
export const POSTA_VUOTA = {
    enabled: false,
    from_address: '',
    from_name: 'SportID',
    host: '',
    port: null,
    username: '',
    password: '',
    encryption: 'tls',
    test_recipient: EMAIL_DI_PROVA,
};

const leggiJson = (chiave, predefinito) => {
    try {
        const v = JSON.parse(localStorage.getItem(chiave) || 'null');
        if (v && typeof v === 'object') return { ...predefinito, ...v };
    } catch { /* storage non disponibile */ }
    return { ...predefinito };
};
const scriviJson = (chiave, v) => {
    try { localStorage.setItem(chiave, JSON.stringify(v)); } catch { /* storage non disponibile */ }
};

const token = () => {
    try { return JSON.parse(sessionStorage.getItem('userDetails')).idToken; } catch { return ''; }
};
const basePath = () => String(process.env.REACT_APP_API_BASE_PATH || '').replace(/\/+$/, '');
const chiama = async (method, path, data) => {
    try {
        const r = await axios.request({ method, url: `${basePath()}${path}`, data, headers: { authorization: token(), accept: 'application/json', 'Content-Type': 'application/json' } });
        return r.data;
    } catch (e) {
        return { error: e.response?.data?.detail || e.response?.data?.message || 'Errore generico', status: e.response?.status };
    }
};

/* ── Solleciti dei certificati medici (cap. 8) ───────────────── */

/** Lettura sincrona per la simulazione dei certificati (calcolo dei solleciti automatici). */
export const sollecitiSimulati = () => leggiJson(CHIAVE_SOLLECITI, SOLLECITI_PREDEFINITI);

export const leggiSolleciti = async () => {
    if (IMPOSTAZIONI_SIMULAZIONE) return sollecitiSimulati();
    const r = await chiama('get', '/administration/settings/medicalCertificateReminders');
    return r?.error ? r : { ...SOLLECITI_PREDEFINITI, ...r };
};

export const salvaSolleciti = async (valori) => {
    const dati = {
        firstReminderDays: Number(valori.firstReminderDays),
        secondReminderDays: Number(valori.secondReminderDays),
        thirdReminderDays: Number(valori.thirdReminderDays),
    };
    if (IMPOSTAZIONI_SIMULAZIONE) { scriviJson(CHIAVE_SOLLECITI, dati); return dati; }
    return chiama('put', '/administration/settings/medicalCertificateReminders', dati);
};

/* ── Posta in uscita (cap. 9) ─────────────────────────────────── */

export const leggiPosta = async () => {
    if (IMPOSTAZIONI_SIMULAZIONE) {
        const v = leggiJson(CHIAVE_POSTA, POSTA_VUOTA);
        return { ...v, password: '', password_set: !!v.password };
    }
    const r = await chiama('get', '/administration/settings/mail');
    return r?.error ? r : { ...POSTA_VUOTA, ...r, password: '' };
};

export const salvaPosta = async (form) => {
    if (IMPOSTAZIONI_SIMULAZIONE) {
        const prima = leggiJson(CHIAVE_POSTA, POSTA_VUOTA);
        // Password vuota = non cambiarla
        scriviJson(CHIAVE_POSTA, { ...form, password: form.password || prima.password });
        return {};
    }
    return chiama('put', '/administration/settings/mail', { ...form, password: form.password || undefined });
};

export const testaConnessione = async (form) => {
    if (IMPOSTAZIONI_SIMULAZIONE) {
        return { simulazione: true, message: `Simulazione: la connessione a ${form.host}:${form.port} si potrà provare davvero quando il backend avrà la rotta.` };
    }
    const r = await chiama('post', '/administration/settings/mail/test', { host: form.host, port: form.port, username: form.username || null, password: form.password || null, encryption: form.encryption });
    return r;
};

export const inviaEmailDiProva = async (form) => {
    if (IMPOSTAZIONI_SIMULAZIONE) {
        return { simulazione: true, message: `Simulazione: l'email di test a ${form.test_recipient} partirà davvero quando il backend avrà la rotta.` };
    }
    return chiama('post', '/administration/settings/mail/send-test', {
        recipient: form.test_recipient, host: form.host, port: form.port, username: form.username || null,
        password: form.password || null, encryption: form.encryption, from_address: form.from_address, from_name: form.from_name,
    });
};
